import * as React from 'react';

const QuickReplies24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M21.169 4.306q.08.207.081.445v9.44a1.25 1.25 0 0 1-1.065 1.237L1.632 18.172a.75.75 0 1 0 .223 1.484l18.553-2.745a2.75 2.75 0 0 0 2.342-2.72v-9.44a2.75 2.75 0 0 0-3.174-2.717l-12.5 1.875A2.75 2.75 0 0 0 4.75 6.626v4.288a.75.75 0 0 0 1.5 0V6.626l.001-.06 5.14 3.842a2.75 2.75 0 0 0 3.644-.218zm-1.326-.795-5.869 5.618a1.25 1.25 0 0 1-1.656.099L7.21 5.41l.098-.02 12.5-1.874.036-.005Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.099 14.656a.75.75 0 0 0-.213-1.485l-3.5.5a.75.75 0 0 0 .213 1.485zm6.257 6.5a.75.75 0 0 0-.212-1.484l-7 1a.75.75 0 0 0 .212 1.484z"
  }
));
QuickReplies24.Size = 24;
QuickReplies24.Title = "QuickReplies";

export { QuickReplies24 as default };
